import { default as ManageFollowup } from "./Home";

export default { ManageFollowup };